// extracted by mini-css-extract-plugin
export default {"container":"PlainButton_container__+mfed"};